import { Loader2 } from "lucide-react";

interface PageLoaderProps {
  /** Additional CSS class for the container */
  className?: string;
  /** Text shown below the spinner */
  text?: string;
}

/**
 * Loader de página completa reutilizable.
 * Usado como fallback mientras se cargan datos iniciales o roles.
 */
export const PageLoader = ({ className = "bg-background", text }: PageLoaderProps) => (
  <div className={`flex min-h-screen flex-col items-center justify-center gap-3 ${className}`}>
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
    {text && <p className="text-sm text-muted-foreground">{text}</p>}
  </div>
);
